import { render, staticRenderFns } from "./FailedBill.vue?vue&type=template&id=275870b5&scoped=true"
import script from "./FailedBill.vue?vue&type=script&lang=js"
export * from "./FailedBill.vue?vue&type=script&lang=js"
import style0 from "./FailedBill.vue?vue&type=style&index=0&id=275870b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275870b5",
  null
  
)

export default component.exports